interface JwtPayload {
  sub: string;
  email: string;
  role: string;
  exp: number;
  iat: number;
}

/**
 * Decode JWT token without verification (client-side only).
 * Returns null if token is malformed.
 */
export function decodeToken(token: string): JwtPayload | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = JSON.parse(atob(parts[1]));
    return payload as JwtPayload;
  } catch {
    return null;
  }
}

/**
 * Check if a JWT token is expired or will expire within `bufferMs` milliseconds.
 * Default buffer is 60 seconds to proactively refresh before actual expiry.
 */
export function isTokenExpired(token: string | null, bufferMs = 60_000): boolean {
  if (!token) return true;

  const payload = decodeToken(token);
  if (!payload?.exp) return true;

  const expiresAt = payload.exp * 1000; // JWT exp is in seconds
  return Date.now() + bufferMs >= expiresAt;
}
